var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75758 1.59091C1.58076 1.59091 1.41119 1.66115 1.28617 1.78617C1.16115 1.91119 1.09091 2.08076 1.09091 2.25758V10.6377L2.584 9.14458C2.6863 9.04232 2.82503 8.98487 2.96969 8.98487H10.2424C10.4192 8.98487 10.5888 8.91461 10.7138 8.78959C10.8388 8.66458 10.9091 8.49498 10.9091 8.31818V2.25758C10.9091 2.08076 10.8388 1.91119 10.7138 1.78617C10.5888 1.66115 10.4192 1.59091 10.2424 1.59091H1.75758ZM0.514785 1.01478C0.844393 0.685171 1.29144 0.5 1.75758 0.5H10.2424C10.7086 0.5 11.1556 0.685171 11.4852 1.01478C11.8148 1.34439 12 1.79144 12 2.25758V8.31818C12 8.78428 11.8148 9.23134 11.4852 9.56094C11.1556 9.89061 10.7086 10.0758 10.2424 10.0758H3.19563L0.931149 12.3402C0.775149 12.4962 0.540538 12.5429 0.33672 12.4585C0.132895 12.374 0 12.1751 0 11.9545V2.25758C0 1.79144 0.185171 1.34439 0.514785 1.01478Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.10312efad97687be429939dc3e0ab505.svg";
export { ForwardRef as ReactComponent };